import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import FloralDivider from "./components/FloralDivider";
import About from "./components/About";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";

// Home page component with all sections
function HomePage() {
  return (
    <div className="bg-cream-50">
      <Header />
      <main>
        <Hero />
        <FloralDivider />
        <About />
        <FloralDivider variant="rose" />
        <Services />
        <FloralDivider variant="gold" />
        <Gallery />
        <FloralDivider variant="rose" />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
